import { ACCOUNTS_PREFIX } from "@cti-workspace/helpers";
import { postApi } from "./api";

export default async function ShareCredentialOverEmail(email, credentialUrl) {
	const url = `/${ACCOUNTS_PREFIX}/shareCredential`;
	return postApi(url, { email, credentialUrl });
}
